import React from 'react';
import CourseBanner from './CourseBanner';
import { getAllCourseKeys, getCourseConfig } from '../config/courses';
import './CourseBannerLayout.scss';

const CourseBannerLayout = ({ 
  onCourseClick, 
  isOpen, 
  disabledCourses = [] 
}) => {
  // Only show "My First Two Weeks" course
  const courseKey = 'first-two-weeks';
  const courseConfig = getCourseConfig(courseKey);
  const isDisabled = disabledCourses.includes(courseKey);

  return (
    <div className={`course-banner-layout ${isOpen ? 'sidebar-open' : ''}`}>
      <div className="course-banner-container">
        <CourseBanner
          courseConfig={courseConfig}
          onClick={() => onCourseClick(courseKey)}
          isOpen={isOpen}
          isDisabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default CourseBannerLayout; 